import React from 'react';
const SuInstantPageIcon = () => {
  return <svg width="87" height="72" viewBox="0 0 87 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12938_37689)">
      <path d="M0 0H86.4V72H0V0Z" fill="white" />
      <path d="M75.6008 36.0016C75.6008 53.8957 61.0949 68.4016 43.2008 68.4016C25.3066 68.4016 10.8008 53.8957 10.8008 36.0016C10.8008 18.1074 25.3066 3.60156 43.2008 3.60156C61.0949 3.60156 75.6008 18.1074 75.6008 36.0016Z" fill="#F0F1F2" />
      <mask id="mask0_12938_37689" style={{ maskType: "alpha"}} maskUnits="userSpaceOnUse" x="-6" y="3" width="82" height="66">
        <path d="M43.2886 3.60156C61.1345 3.60156 75.6 18.1074 75.6 36.0016C75.6 53.8957 61.1345 68.4016 43.2886 68.4016H-5.61523V3.60156H43.2886Z" fill="white" />
      </mask>
      <g mask="url(#mask0_12938_37689)">
        <g filter="url(#filter0_d_12938_37689)">
          <path d="M10.6677 60.9869H76.1682C77.146 60.9869 77.9387 60.2778 77.9344 59.403V13.0558C77.9344 12.5893 77.7491 12.1419 77.4192 11.8121C77.0893 11.4822 76.6419 11.2969 76.1754 11.2969H10.6554C10.1889 11.2969 9.74154 11.4822 9.41167 11.8121C9.0818 12.1419 8.89648 12.5893 8.89648 13.0558V59.4022C8.89648 60.277 9.68848 60.9862 10.6677 60.9862V60.9869Z" fill="white" />
        </g>
        <path d="M8.8972 22.7298H77.9351V12.8211C77.9351 11.9787 77.0942 11.2969 76.0566 11.2969H10.7757C9.73888 11.2969 8.89648 11.9794 8.89648 12.8211V22.7298H8.8972Z" fill="#42474C" />
        <path d="M68.3998 33.8438H15.8398V46.0838H68.3998V33.8438Z" fill="#7FBEC6" />
        <path d="M52.5598 33.8438H15.8398V46.0838H52.5598V33.8438Z" fill="#1A7F61" />
        <circle cx="14.4009" cy="17.2838" r="1.44" fill="white" />
        <circle cx="20.8814" cy="17.2838" r="1.44" fill="white" />
        <circle cx="27.3619" cy="17.2838" r="1.44" fill="white" />
      </g>
    </g>
    <defs>
      <filter id="filter0_d_12938_37689" x="1.69648" y="5.53688" width="83.4371" height="64.0899" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1.44" />
        <feGaussianBlur stdDeviation="3.6" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12938_37689" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12938_37689" result="shape" />
      </filter>
      <clipPath id="clip0_12938_37689">
        <rect width="86.4" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>

};

export default SuInstantPageIcon;

